import { Tag as AntTag } from "antd";
import styled from "styled-components";

export const Tag = styled(AntTag)`
  border: 1px solid ${(props) => (props.color ? props.color : "#323232")};
  border-radius: 0;
`;
